import { useSelector } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import * as AbsolutePaths from 'automation-ui-canvas/constants/AbsolutePaths';
import { AiAssistants } from 'automation-ui-canvas/constants/AiAssistant';
import Flow from 'automation-ui-canvas/flow/records/Flow';
import { getClassicEnrollmentSettings } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { useGetFlowById } from 'automation-ui-canvas/queries/flowQueries';
import { useGetUpdateFlowLists } from 'automation-ui-canvas/queries/flowListsQueries';
import { getCurrentlyStagedFlowByFlowId } from 'automation-ui-canvas/selectors/flowSelectors';
import { getExistingTriggerType } from 'automation-ui-enrollment/utils/EnrollmentDeciders';
import { jsx as _jsx } from "react/jsx-runtime";
export default function KeepSuggestedTriggerButton({
  flowId,
  orFilterGroups
}) {
  const history = useHistory();
  const trackEvent = useTrackEvent();
  const {
    data: flowByIdData
  } = useGetFlowById(flowId);
  const fetchedFlow = flowByIdData === null || flowByIdData === void 0 ? void 0 : flowByIdData.flowById;
  const currentlyStagedFlow = useSelector(getCurrentlyStagedFlowByFlowId(flowId));
  const [updateFlowLists, {
    loading
  }] = useGetUpdateFlowLists();
  const handleKeepButtonClick = () => {
    trackEvent(Trackables.INSERT_GENERATED_ASSET, {
      aiPrompt: orFilterGroups.map(fg => fg.filterInputs.join(' AND ')).join(' OR '),
      assetType: 'AI Generated Workflow Trigger',
      flowId
    });
    const hybridFlow = fetchedFlow === null || fetchedFlow === void 0 ? void 0 : fetchedFlow.toHybridFlowInterface();
    const hasExistingTrigger = hybridFlow && !!getExistingTriggerType(hybridFlow);
    if (hasExistingTrigger) {
      const classicEnrollmentSettings = getClassicEnrollmentSettings(hybridFlow);
      updateFlowLists({
        flowId,
        opts: {
          data: {
            associatedLists: [],
            enrollmentCriteria: {
              operation: 'DELETE'
            },
            classicEnrollmentSettings: classicEnrollmentSettings ? Object.assign({}, classicEnrollmentSettings, {
              reEnrollmentTriggerSets: []
            }) : undefined
          }
        },
        sourceApp: SourceApps.WORKFLOWS_APP,
        aiAssistants: [AiAssistants.WORKFLOWS_AI_ASSISTANT]
      }).then(updatedFlow => {
        const formattedFlow = new Flow(updatedFlow);
        return updateFlowLists({
          flowId,
          opts: {
            data: {
              associatedLists: formattedFlow.getAssociatedListsAsNew().toJS(),
              enrollmentCriteria: {
                operation: 'UPSERT',
                value: currentlyStagedFlow.enrollmentCriteria
              }
            }
          },
          sourceApp: SourceApps.WORKFLOWS_APP,
          aiAssistants: [AiAssistants.WORKFLOWS_AI_ASSISTANT]
        });
      }).then(() => {
        history.push(generatePath(AbsolutePaths.CANVAS_ROOT_WORKFLOW, {
          flowId
        }));
      }).catch(error => {
        console.error('AIAssistantGenerateFlowHeader error: ', error);
      });
    } else {
      updateFlowLists({
        flowId,
        opts: {
          data: {
            associatedLists: fetchedFlow.getAssociatedListsAsNew().toJS(),
            enrollmentCriteria: {
              operation: 'UPSERT',
              value: currentlyStagedFlow.enrollmentCriteria
            }
          }
        },
        sourceApp: SourceApps.WORKFLOWS_APP,
        aiAssistants: [AiAssistants.WORKFLOWS_AI_ASSISTANT]
      }).then(() => {
        history.push(generatePath(AbsolutePaths.CANVAS_ROOT_WORKFLOW, {
          flowId
        }));
      }).catch(error => {
        // TODO - @mlegocki: handle errors
        console.error('AIAssistantGenerateFlowHeader error: ', error);
      });
    }
  };
  return /*#__PURE__*/_jsx(UILoadingButton, {
    "data-test-id": "ai-assistant-nav-save-button",
    loading: loading,
    onClick: handleKeepButtonClick,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.aiAssistantGenerateCanvas.header.keepTriggersButton"
    })
  });
}